import React, { useState, useEffect } from "react";
import Cell from "../assets/Cell.svg";
import { toast, ToastContainer } from "react-toastify";
import { validateToken } from "../tokenValidation";
import { useNavigate } from "react-router-dom";
import secureStorage from "../utils/secureStorage";
const CustomersList = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(10); // Default page size
  const [totalPages, setTotalPages] = useState(0);

  // Modal States
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [aboutDocument, setAboutDocument] = useState("");
  const [practitioners, setPractitioners] = useState([]);
  const [selectedPractitioner, setSelectedPractitioner] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();

      useEffect(() => {
          validateToken(navigate);
      }, [navigate]);

  useEffect(() => {
    fetchCustomers();
  }, [pageNumber]);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const token = secureStorage.get("authToken");
      // const clinicId = secureStorage.get("clinic");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }
      const orgId = secureStorage.get("orgId");
      const response = await fetch(
        `${API_URL}hospital/patients?pageNumber=${pageNumber}&pageSize=${pageSize}?orgId=${orgId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCustomers(data.data.content || []);
        setFilteredCustomers(data.data.content || []);
        setTotalPages(data.data.totalPages || 0);
      } else {
        console.error("Failed to fetch customers:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };


  const fetchPractitioners = async () => {
    try {
      const token = secureStorage.get("authToken");
      const orgId = secureStorage.get("orgId");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }

      const response = await fetch(`${API_URL}hospital/get-active-practitioners?orgId=${orgId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-HIP-ID": secureStorage.get("clinic"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        setPractitioners(data.data || []);
      } else {
        console.error("Failed to fetch practitioners:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching practitioners:", error);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    if (e.target.value === "") {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter((customer) =>
        customer.firstName && customer.lastName // Check if both exist
          ? `${customer.firstName} ${customer.lastName}`
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
          : false
      );
      setFilteredCustomers(filtered);
    }
  };

  const handleUploadClick = (customer) => {
    setSelectedCustomer(customer);
    setModalOpen(true);
    fetchPractitioners();
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };


  const documentTypeMapping = {
    "Prescription": "Prescription",
    "Diagnostic Report": "DiagnosticReport",
    "OP Consultation": "OPConsultation",
    "Discharge Summary": "DischargeSummary",
    "Immunization Record": "ImmunizationRecord",
    "Health Document Record": "HealthDocumentRecord",
    "Wellness Record": "WellnessRecord",
    "Invoice": "Invoice",
  };


  const [uploading, setUploading] = useState(false);
  const handleUpload = async () => {

    setUploading(true);
    if (!documentType || !selectedFile || !aboutDocument) {
      toast.error("Please fill all fields before uploading.");
      return;
    }
    const apiDocumentType = documentTypeMapping[documentType];


    const formData = new FormData();
    formData.append("file", selectedFile);
    // formData.append("aboutDocument", aboutDocument);



    try {
      const token = secureStorage.get("authToken");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }

      const response = await fetch(
        `${API_URL}abdm-data-share/upload?abhaNumber=${selectedCustomer.abhaNumber}&documentType=${apiDocumentType}&practitionerId=${selectedPractitioner}&aboutDocument=${aboutDocument}`,

        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "X-HIP-ID": secureStorage.get("clinic"),
          },
          body: formData,
        }
      );

      if (response.ok) {
        toast.success("Document uploaded successfully!");
        setModalOpen(false);
        setSelectedCustomer(null);
        setDocumentType("");
        setSelectedFile(null);
        setSelectedPractitioner("");
        setAboutDocument("");
      } else {
        console.error("Failed to upload document:", response.statusText);
        toast.error("Failed to upload document.");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Error uploading document.");
    }
   finally {
    setUploading(false);
  }
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedCustomer(null);
    setDocumentType("");
    setSelectedFile(null);
    setSelectedPractitioner("");
    setAboutDocument("");
  };

  return (
    <div className="bg-[#F6F6F6] min-h-screen p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Customers’ List</h1>

      {/* Search Bar */}
      <div className="flex justify-end mb-4">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search by Name"
          className="p-2 w-64 border border-gray-300 rounded-l-md focus:ring-2 focus:ring-teal-500 focus:outline-none"
        />
        <button
          onClick={handleSearch}
          className="bg-teal-500 text-white px-4 rounded-r-md hover:bg-teal-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </button>
      </div>

      {/* Table */}
      <div
        className="rounded-lg overflow-hidden shadow-md"
        style={{ backgroundColor: "#DEEBEC" }}
      >
        {loading ? (
          <p className="text-center py-4">Loading...</p>
        ) : filteredCustomers.length === 0 ? (
          <p className="text-center py-4">No customers found</p>
        ) : (
          <table className="w-full table-auto">
            <thead className="bg-[#DEEBEC] border-b border-[#0F766E]">
              <tr>
                <th className="px-4 py-5 text-left text-[15px] font-semibold text-[#0F766E]">
                  Customer Name
                </th>
                <th className="px-4 py-5 text-left text-[15px] font-semibold text-[#0F766E]">
                  ABHA Number
                </th>
                <th className="px-4 py-5 text-left text-[15px] font-semibold text-[#0F766E]">
                  ABHA Address
                </th>
                <th className="px-4 py-5 text-center text-[15px] font-semibold text-[#0F766E]">
                  Upload
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.map((customer, index) => (
                <tr
                  key={index}
                  className="bg-[#DEEBEC] border-b border-[#C6D9DB]"
                >
                  <td className="px-4 py-2 text-sm font-medium text-gray-700">
                    {customer.firstName} {customer.lastName}
                  </td>
                  <td className="px-4 py-2 text-sm font-medium text-gray-700">
                    {customer.abhaNumber}
                  </td>
                  <td className="px-4 py-2 text-sm font-medium text-gray-700">
                    {customer.preferredAbhaAddress}
                  </td>
                  <td className="px-4 py-2 text-center">
                    <button onClick={() => handleUploadClick(customer)}>
                      <img
                        src={Cell}
                        alt="Upload Icon"
                        className="w-12 h-12 inline"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-4">
        <button
          disabled={pageNumber === 0}
          onClick={() => setPageNumber((prev) => Math.max(prev - 1, 0))}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 disabled:opacity-50"
        >
          Previous
        </button>
        <span>
          Page {pageNumber + 1} of {totalPages}
        </span>
        <button
          disabled={pageNumber + 1 >= totalPages}
          onClick={() => setPageNumber((prev) => prev + 1)}
          className="bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600"
        >
          Next
        </button>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-w-4xl">
            <h2 className="text-2xl font-bold mb-4">Upload Document</h2>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                Document Type
              </label>
              <select
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
                className="w-full border border-gray-300 p-2 rounded-md"
              >
                <option value="">Select Document Type</option>
                <option value="Prescription">Prescription</option>
                <option value="Diagnostic Report">Diagnostic Report</option>
                <option value="OP Consultation">OP Consultation</option>
                <option value="Discharge Summary">Discharge Summary</option>
                <option value="Immunization Record">Immunization Record</option>
                <option value="Health Document Record">Health Document Record</option>
                <option value="Wellness Record">Wellness Record</option>
                <option value="Invoice">Invoice</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                About Document
              </label>
              <textarea
                value={aboutDocument}
                onChange={(e) => setAboutDocument(e.target.value)}
                className="w-full border border-gray-300 p-2 rounded-md"
                placeholder="Describe the document here..."
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                Select Practitioner
              </label>
              <select
                value={selectedPractitioner}
                onChange={(e) => setSelectedPractitioner(e.target.value)}
                className="w-full border border-gray-300 p-2 rounded-md"
              >
                <option value="">Select Practitioner</option>
                {practitioners.map((practitioner) => (
                  <option key={practitioner.healthcareProfessionalId} value={practitioner.healthcareProfessionalId}>
                    {practitioner.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                Upload File
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                className="w-full border border-gray-300 p-2 rounded-md"
              />
            </div>
            <div className="flex justify-end">
              <button
                 className="bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600 disabled:bg-gray-300"
                onClick={handleUpload}
              >
                Upload
              </button>
              <button
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default CustomersList;
